  import React, { useEffect, useState } from "react";

  import axios from "axios";

  import Swal from "sweetalert2"; // Added SweetAlert2

  import { useNavigate } from "react-router-dom";
  import { API_BASE_URL } from "../config/api";

  import {

    FaTrashAlt,

    FaPlus,

    FaMinus,

    FaShoppingBag,

    FaUserCircle,
    FaShieldAlt,

    FaTruck,

    FaArrowLeft,

  } from "react-icons/fa";

  const getCartImageUrl = (uniform) => {
    const imagePath =
      Array.isArray(uniform?.images) && uniform.images.length > 0
        ? uniform.images[0]
        : uniform?.image;

    if (!imagePath) return "https://via.placeholder.com/100x110?text=No+Image";

    const cleanPath = String(imagePath)
      .replace(/\\/g, "/")
      .replace(/^\/+/, "");

    if (cleanPath.startsWith("http")) return cleanPath;
    if (cleanPath.startsWith("uploads/")) return `${API_BASE_URL}/${cleanPath}`;

    return `${API_BASE_URL}/uploads/${cleanPath}`;
  };



  function CartPage() {

    const [cart, setCart] = useState([]);

    const [loading, setLoading] = useState(true);



    const navigate = useNavigate();

    const parentId = localStorage.getItem("parentId");



    useEffect(() => {

      loadCart();

    }, []);



    const loadCart = async () => {

      if (!parentId) return;

      try {

        const res = await axios.get(`${API_BASE_URL}/cart/${parentId}`);

        setCart(res.data);

      } catch (err) {

        console.error(err);

      } finally {

        setLoading(false);

      }

    };



    const increaseQty = async (id) => {

      try {

        await axios.put(`${API_BASE_URL}/cart/increase/${id}`);

        loadCart();

        // Dispatch cart update event to refresh header counter

        window.dispatchEvent(new Event("cartUpdate"));

      } catch (err) {

        Swal.fire({

          icon: "error",

          title: "Error",

          text: "Could not update quantity",

        });

      }

    };



    const decreaseQty = async (id) => {

      try {

        await axios.put(`${API_BASE_URL}/cart/decrease/${id}`);

        loadCart();

        // Dispatch cart update event to refresh header counter

        window.dispatchEvent(new Event("cartUpdate"));

      } catch (err) {

        Swal.fire({

          icon: "error",

          title: "Error",

          text: "Could not update quantity",

        });

      }

    };



    // ⭐ Updated with SweetAlert2

    const confirmDelete = (id) => {

      Swal.fire({

        title: "Remove Item?",

        text: "Are you sure you want to remove this uniform from your bag?",

        icon: "warning",

        showCancelButton: true,

        confirmButtonColor: "#d33",

        cancelButtonColor: "#6e7881",

        confirmButtonText: "Yes, Remove",

        cancelButtonText: "Cancel",

      }).then(async (result) => {

        if (result.isConfirmed) {

          try {

            await axios.delete(`${API_BASE_URL}/cart/${id}`);

            setCart(cart.filter((item) => item._id !== id));

            // Dispatch cart update event to refresh header counter
            window.dispatchEvent(new Event("cartUpdate"));

            // Success Toast

            Swal.fire({

              icon: "success",

              title: "Removed!",

              text: "Item removed from bag",

              timer: 1500,

              showConfirmButton: false,

            });

          } catch (err) {

            Swal.fire({

              icon: "error",

              title: "Error",

              text: "Could not remove item",

            });

          }

        }

      });

    };



    // Calculations

    const subtotal = cart.reduce(

      (acc, item) => acc + (item.uniformId?.price || 0) * item.quantity,

      0,

    );

    const deliveryFee = subtotal > 1000 || subtotal === 0 ? 0 : 50;

    const gst = subtotal * 0.05;

    const finalTotal = subtotal;



    // Group By Child

    const groupedCart = cart.reduce((acc, item) => {

      const key = item.childId || "General";

      if (!acc[key]) acc[key] = [];

      acc[key].push(item);

      return acc;

    }, {});



    if (loading)

      return (

        <div className="loader-box">

          <div className="spinner-p"></div>

        </div>

      );



    return (

      <div className="cart-modern-container">

        <div className="container py-5">

          <div className="d-flex align-items-center mb-4">

            <button

              className="btn-back-minimal"

              onClick={() => navigate("/parent/uniform")} // S hata diya hai, ab match karega

            >

              <FaArrowLeft />

            </button>



            <h2 className="cart-title ms-3">

              Shopping Bag{" "}

              <span className="item-count">({cart.length} items)</span>

            </h2>

          </div>



          {cart.length === 0 ? (

            <div className="empty-cart-state text-center py-5">

              <div className="empty-icon">

                <FaShoppingBag />

              </div>

              <h3>Your bag is empty</h3>

              <p>Looks like you haven't added any uniforms yet.</p>

              <button className="btn-shop-now" onClick={() => navigate("/parent/uniform")}>

                Browse Shop

              </button>

            </div>

          ) : (

            <div className="row g-4">

              <div className="col-lg-8">

                {cart.map((item, index) => (
                  <div className="cart-item-card" key={item._id}>
                    <div className="item-img-box">
                      <img
                        src={getCartImageUrl(item.uniformId)}
                        alt="item"
                      />
                    </div>

                    <div className="item-details">
                      <div className="d-flex justify-content-between">
                        <h6 className="item-name">{item.uniformId?.name}</h6>
                        <button
                          className="btn-remove-icon"
                          onClick={() => confirmDelete(item._id)}
                        >
                          <FaTrashAlt />
                        </button>
                      </div>
                      <p className="item-meta">
                        Size: <strong>{item.size}</strong>
                      </p>

                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <div className="qty-controller-p">
                          <button
                            onClick={() => decreaseQty(item._id)}
                            disabled={item.quantity <= 1}
                          >
                            <FaMinus />
                          </button>
                          <span>{item.quantity}</span>
                          <button onClick={() => increaseQty(item._id)}>
                            <FaPlus />
                          </button>
                        </div>
                        <div className="item-price">
                          ₹
                          {(
                            item.uniformId?.price * item.quantity
                          ).toLocaleString()}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

              </div>

              <div className="col-lg-4">
                <div className="summary-card-p" style={{ top: "100px" }}>
                  <div className="summary-header">
                    <div className="summary-icon-wrapper">
                      <FaShoppingBag className="summary-main-icon" />
                    </div>
                    <div>
                      <h5 className="summary-title">Order Summary</h5>
                      <p className="summary-subtitle">Review your cart total</p>
                    </div>
                  </div>
                  
                  <div className="summary-content">
                    <div className="summary-products">
                      <div className="summary-section-label">Product Price</div>
                      {cart.map((item) => {
                        const price = Number(item.uniformId?.price || 0);
                        const itemTotal = price * Number(item.quantity || 0);

                        return (
                          <div className="summary-product-row" key={item._id}>
                            <div className="summary-product-info">
                              <span className="summary-product-name">
                                {item.uniformId?.name || "Uniform Item"}
                              </span>
                              <span className="summary-product-meta">
                                {item.size ? `Size: ${item.size} | ` : ""}Qty: {item.quantity}
                              </span>
                            </div>
                            <span className="summary-product-price">
                              ₹{itemTotal.toFixed(2)}
                            </span>
                          </div>
                        );
                      })}
                    </div>

                    <div className="summary-divider-modern"></div>

                    <div className="summary-row-modern">
                      <span className="summary-label-text">Subtotal</span>
                      <span className="summary-value-text">₹{subtotal.toFixed(2)}</span>
                    </div>

                    <div className="summary-row-modern">
                      <span className="summary-label-text">All tax included</span>
                      <span className="summary-value-text">Included</span>
                    </div>



                    <div className="summary-divider-modern"></div>
                    
                    <div className="total-row-modern">
                      <div className="total-info">
                        <span className="total-label">Total Amount</span>
                        <span className="total-description">Including all charges</span>
                      </div>
                      <div className="total-amount-wrapper">
                        <span className="total-amount">₹{finalTotal.toFixed(2)}</span>
                      </div>
                    </div>
                  </div>

                  <button className="btn-checkout-p" onClick={() => navigate("/checkout")}>
                    <div className="button-content">
                      <FaShoppingBag className="btn-icon" />
                      <span>Proceed to Checkout</span>
                    </div>
                  </button>
                  
                  <div className="security-badge">
                    <FaShieldAlt className="security-icon" />
                    <span>Secure SSL Encrypted Checkout</span>
                  </div>
                </div>
              </div>

            </div>

          )}

        </div>



        <style>{`

          @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&display=swap');

          

          /* Main Styles */

          .cart-modern-container { background: #fcfdfe; font-family: 'Plus Jakarta Sans', sans-serif; min-height: 100vh; }

          .btn-back-minimal { border: 1px solid #e2e8f0; background: white; width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; transition: 0.3s; }

          .btn-back-minimal:hover { background: #0f172a; color: white; }

          .cart-title { font-weight: 800; color: #0f172a; margin: 0; }

          .item-count { color: #64748b; font-size: 1.1rem; font-weight: 500; }

          .child-header { display: flex; align-items: center; margin-bottom: 15px; font-size: 0.95rem; color: #475569; padding-left: 5px; }

          .cart-item-card { background: white; border-radius: 20px; border: 1px solid #f1f5f9; padding: 15px; display: flex; gap: 20px; margin-bottom: 15px; transition: 0.3s; }

          .cart-item-card:hover { border-color: #3b82f6; box-shadow: 0 10px 25px rgba(0,0,0,0.02); }

          .item-img-box { width: 100px; height: 110px; background: #f8fafc; border-radius: 15px; display: flex; align-items: center; justify-content: center; padding: 10px; }

          .item-img-box img { max-width: 100%; max-height: 100%; object-fit: contain; }

          .item-details { flex-grow: 1; }

          .item-name { font-weight: 700; color: #1e293b; font-size: 1rem; margin-bottom: 5px; }

          .item-meta { color: #64748b; font-size: 0.85rem; }

          .item-price { font-weight: 800; font-size: 1.1rem; color: #0f172a; }

          .btn-remove-icon { background: #fee2e2; color: #ef4444; border: none; width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 0.8rem; transition: 0.3s; }

          .btn-remove-icon:hover { background: #ef4444; color: white; }

          .qty-controller-p { display: flex; align-items: center; background: #f1f5f9; border-radius: 10px; padding: 4px; }

          .qty-controller-p button { border: none; background: white; width: 28px; height: 28px; border-radius: 8px; font-size: 0.7rem; display: flex; align-items: center; justify-content: center; transition: 0.2s; }

          .qty-controller-p button:hover { background: #3b82f6; color: white; }

          .qty-controller-p span { padding: 0 15px; font-weight: 700; font-size: 0.9rem; }

          .summary-card-p { 
            background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%); 
            border-radius: 28px; 
            border: 1px solid #e2e8f0; 
            padding: 32px; 
            box-shadow: 0 20px 40px rgba(0,0,0,0.06); 
            position: sticky;
          }
          
          .summary-header {
            display: flex;
            align-items: center;
            gap: 16px;
            margin-bottom: 28px;
            padding-bottom: 20px;
            border-bottom: 2px solid #f1f5f9;
          }
          
          .summary-icon-wrapper {
            background: linear-gradient(135deg, #10b981 0%, #059669 100%);
            width: 56px;
            height: 56px;
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 8px 20px rgba(16, 185, 129, 0.25);
          }
          
          .summary-main-icon {
            color: white;
            font-size: 1.6rem;
          }
          
          .summary-title { 
            font-weight: 800; 
            margin-bottom: 4px; 
            color: #1e293b; 
            font-size: 1.4rem;
          }
          
          .summary-subtitle {
            color: #64748b;
            font-size: 0.875rem;
            margin: 0;
            font-weight: 500;
          }
          
          .summary-content {
            margin-bottom: 24px;
          }

          .summary-products {
            background: #ffffff;
            border: 1px solid #eef2f7;
            border-radius: 16px;
            padding: 14px;
            margin-bottom: 16px;
          }

          .summary-section-label {
            font-size: 0.8rem;
            font-weight: 800;
            color: #0f172a;
            text-transform: uppercase;
            margin-bottom: 10px;
          }

          .summary-product-row {
            display: flex;
            justify-content: space-between;
            gap: 12px;
            padding: 10px 0;
            border-bottom: 1px solid #f1f5f9;
          }

          .summary-product-row:last-child {
            border-bottom: 0;
            padding-bottom: 0;
          }

          .summary-product-info {
            min-width: 0;
          }

          .summary-product-name {
            display: block;
            font-weight: 700;
            color: #1e293b;
            font-size: 0.9rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 170px;
          }

          .summary-product-meta {
            display: block;
            color: #64748b;
            font-size: 0.78rem;
            margin-top: 2px;
          }

          .summary-product-price {
            color: #0f172a;
            font-weight: 800;
            font-size: 0.9rem;
            white-space: nowrap;
          }
          
          .summary-row-modern { 
            display: flex; 
            justify-content: space-between; 
            margin-bottom: 16px; 
            align-items: center;
          }
          
          .summary-label-text {
            color: #64748b; 
            font-weight: 500; 
            font-size: 0.95rem;
          }
          
          .summary-value-text {
            color: #1e293b; 
            font-weight: 600; 
            font-size: 0.95rem;
          }
          
          .summary-divider-modern { 
            height: 2px; 
            background: linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 100%); 
            margin: 20px 0; 
            border-radius: 2px;
          }
          
          .total-row-modern {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px;
            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
            border-radius: 20px;
            border: 2px solid #bbf7d0;
            margin-bottom: 24px;
          }
          
          .total-info {
            flex: 1;
          }
          
          .total-label {
            display: block;
            font-weight: 800;
            color: #1e293b;
            font-size: 1.1rem;
            line-height: 1.2;
          }
          
          .total-description {
            color: #64748b;
            font-size: 0.8rem;
            font-weight: 500;
            margin-top: 2px;
          }
          
          .total-amount-wrapper {
            text-align: right;
          }
          
          .total-amount {
            font-weight: 800;
            color: #10b981;
            font-size: 1.5rem;
            display: block;
          }
          
          .delivery-tip-enhanced { 
            background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%); 
            color: #0369a1; 
            padding: 12px 16px; 
            border-radius: 16px; 
            font-size: 0.8rem; 
            font-weight: 600; 
            margin-bottom: 20px; 
            display: flex;
            align-items: center;
            gap: 8px;
            border: 1px solid #bae6fd;
          }
          
          .delivery-icon {
            font-size: 0.9rem;
          }
          
          .btn-checkout-p { 
            width: 100%; 
            padding: 18px; 
            border-radius: 20px; 
            border: none; 
            background: #097969;
            color: white; 
            font-weight: 700; 
            font-size: 1.1rem; 
            transition: all 0.3s ease; 
            cursor: pointer;
            position: relative;
            overflow: hidden;
            margin-bottom: 20px;
            box-shadow: 0 10px 25px rgba(9, 121, 105, 0.3);
          }
          
          .btn-checkout-p::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
            transition: left 0.5s ease;
          }
          
          .btn-checkout-p:hover::before {
            left: 100%;
          }
          
          .btn-checkout-p:hover { 
            transform: translateY(-2px);
            box-shadow: 0 15px 35px rgba(9, 121, 105, 0.4); 
          }
          
          .button-content {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
          }
          
          .btn-icon {
            font-size: 1.1rem;
          }
          
          .security-badge {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            color: #64748b;
            font-size: 0.8rem;
            font-weight: 500;
          }
          
          .security-icon {
            color: #10b981;
            font-size: 0.9rem;
          }

          .empty-icon { font-size: 4rem; color: #e2e8f0; margin-bottom: 20px; }

          .btn-shop-now { background: #097969; color: white; border: none; padding: 12px 30px; border-radius: 50px; font-weight: 600; margin-top: 20px; }

          .spinner-p { width: 40px; height: 40px; border: 4px solid #f1f5f9; border-top-color: #3b82f6; border-radius: 50%; animation: spin 1s linear infinite; }

          @keyframes spin { to { transform: rotate(360deg); } }

          .loader-box { height: 60vh; display: flex; align-items: center; justify-content: center; }



          /* SweetAlert Customization */

          .swal2-popup {

            border-radius: 20px !important;

            font-family: 'Plus Jakarta Sans', sans-serif !important;

          }

          .swal2-title {

            font-weight: 800 !important;

          }

          .swal2-confirm {

            border-radius: 12px !important;

          }

          .swal2-cancel {

            border-radius: 12px !important;

          }

        `}</style>

      </div>

    );

  }



  export default CartPage;

